import { render, staticRenderFns } from "./CustomButton.vue?vue&type=template&id=a8c7d8e8&"
import script from "./CustomButton.vue?vue&type=script&lang=js&"
export * from "./CustomButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports